import React from 'react';
export const ComparisonSection = () => {
  const rows = [{
    sin: 'Tu adolescente explota o se cierra sin saber por qué ni cómo parar.',
    con: 'Protocolo de calma activo en menos de 60 segundos.'
  }, {
    sin: 'La ansiedad le impide rendir, dormir y relacionarse normalmente.',
    con: '3 protocolos de emergencia listos para cualquier situación.'
  }, {
    sin: 'Su autoestima sube y baja con cada like y comentario externo.',
    con: 'Sistema de autoestima sólida basado en evidencia real interna.'
  }, {
    sin: 'Explota impulsivamente y dice cosas que lastiman relaciones.',
    con: 'Cortafuegos de 5 Pasos que crea el espacio entre impulso y acción.'
  }, {
    sin: 'Relaciones tóxicas que drena energía sin saber cómo alejarse.',
    con: 'Semáforo de Vínculos y Firewall Social para proteger su energía.'
  }, {
    sin: 'Sin herramientas de crisis en los peores momentos.',
    con: 'Kit de Emergencia con 8 fichas listas para cualquier crisis.'
  }, {
    sin: 'Los padres no saben cómo hablar sin que se cierre.',
    con: 'Guía para Padres con scripts y estrategias probadas de conexión.'
  }, {
    sin: 'Sin sistema de mantenimiento, los avances se pierden con el tiempo.',
    con: 'Rutina de 5 minutos diarios que mantiene el sistema activo.'
  }, {
    sin: 'La distancia emocional crece y la conexión familiar se deteriora.',
    con: 'Una familia con herramientas reales para conectar de verdad.'
  }];
  return <section className="bg-biosync-bgAlt py-10 px-5 sm:px-10" data-id="element-41">
      <div className="max-w-[1100px] mx-auto" data-id="element-42">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-biosync-text mb-12" data-id="element-43">
          "¿Cuánto cuesta NO tener BIO-SYNC?"
        </h2>

        <div className="hidden md:block bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-200" data-id="element-44">
          <div className="grid grid-cols-2" data-id="element-45">
            <div className="bg-gray-800 text-white font-bold p-6 text-center text-lg" data-id="element-46">
              SIN BIO-SYNC
            </div>
            <div className="bg-biosync text-white font-bold p-6 text-center text-lg" data-id="element-47">
              CON BIO-SYNC ⚡
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-48">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-2" data-id="element-49">
                <div className="p-6 text-biosync-textSec bg-gray-50/50" data-id="element-50">
                  <span className="text-red-400 mr-2" data-id="element-51">❌</span> {row.sin}
                </div>
                <div className="p-6 text-biosync-text font-medium bg-biosync/5" data-id="element-52">
                  <span className="text-biosync mr-2" data-id="element-53">✅</span> {row.con}
                </div>
              </div>)}
          </div>
        </div>

        {/* Mobile view */}
        <div className="md:hidden space-y-6" data-id="element-54">
          {rows.map((row, i) => <div key={i} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-55">
              <div className="p-4 bg-gray-50 border-b border-gray-100" data-id="element-56">
                <div className="text-xs font-bold text-gray-500 mb-2 uppercase" data-id="element-57">
                  Sin BIO-SYNC
                </div>
                <div className="text-biosync-textSec text-sm" data-id="element-58">
                  <span className="text-red-400 mr-1" data-id="element-59">❌</span> {row.sin}
                </div>
              </div>
              <div className="p-4 bg-biosync/5" data-id="element-60">
                <div className="text-xs font-bold text-biosync mb-2 uppercase" data-id="element-61">
                  Con BIO-SYNC ⚡
                </div>
                <div className="text-biosync-text font-medium text-sm" data-id="element-62">
                  <span className="text-biosync mr-1" data-id="element-63">✅</span> {row.con}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};